import { OperationEntity } from '../entities/operation-entity';

export default class State {
  loaded = false;

  items: Array<OperationEntity> = [];
}
